module.exports = __webpack_public_path__ + "static/media/handskar.443c4db6.svg";